import React, { useState, useEffect } from "react";
import {
  Card,
  Form,
  Container,
  Row,
  Col,
  OverlayTrigger,
  Tooltip,
  Button,
} from "react-bootstrap";
import { FaPlus, FaEdit, FaTrash } from "react-icons/fa";
import { IoIosArrowUp } from "react-icons/io";
import resetBtn from "../../assets/images/reset-arrow.svg";
import { getCoupons, deleteCouponById } from "../../actions/couponAction";
import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import FullPageLoader from "../../components/FullPageLoader/FullPageLoader";
import SweetAlert from "react-bootstrap-sweetalert";
import { toast } from "react-toastify";
import DataTable, { createTheme } from "react-data-table-component";
import InitializeLocalStorage from "../../components/PaginationHandle";

createTheme(
  "solarized",
  {
    text: {
      primary: "#000",
      secondary: "#000",
    },
    background: {
      default: "#fff",
    },
    context: {
      background: "#cb4b16",
      text: "#FFFFFF",
    },
    divider: {
      default: "#DFE0EB",
    },
    action: {
      button: "rgba(0,0,0,.54)",
      hover: "rgba(0,0,0,.08)",
      disabled: "rgba(0,0,0,.12)",
    },
  },
  "dark"
);

const formatDate = (value) =>
  value ? new Date(value).toLocaleDateString("en-US") : "-";

const formatDiscount = (row) =>
  row.discountType === "percentage"
    ? `${row.discountValue}%`
    : `$${Number(row.discountValue).toFixed(2)}`;

const formatUsage = (row) =>
  row.usageLimit > 0
    ? `${row.usedCount || 0} / ${row.usageLimit}`
    : `${row.usedCount || 0} / Unlimited`;

const Index = () => {
  const [couponData, setCouponData] = useState([]);
  const [loader, setLoader] = useState(false);
  const { admin } = useSelector((state) => state.admin);
  const currentUserRole = admin.role;
  const [getDelete, setDelete] = useState(false);
  const [deleteId, setDeleteId] = useState("");
  const [filterText, setFilterText] = useState("");
  const [selectedOption, setSelectedOption] = useState("");
  const [filteredItems, setFilteredItems] = useState([]);
  const [isFilterOpen, setIsFilterOpen] = useState(true);

  const location = useLocation();
  const { pathname } = location;

  InitializeLocalStorage(pathname, localStorage.getItem("currentURL"));

  const hideModel = () => {
    setDelete(false);
  };

  const deleteCoupon = async () => {
    setDelete(false);
    setLoader(true);
    let res = await deleteCouponById(deleteId);
    if (res?.data?.success) {
      toast.success(res.data.message);
      getAllCoupons();
    }
    setLoader(false);
  };

  const showModel = (id) => {
    setDeleteId(id);
    setDelete(true);
  };

  const getAllCoupons = async () => {
    setLoader(true);
    let res = await getCoupons({ page: 1, limit: 0 });
    if (res?.data?.data?.coupons) {
      setCouponData(res.data.data.coupons);
    }
    setLoader(false);
  };

  useEffect(() => {
    getAllCoupons();
  }, []);

  const caseInsensitiveSort = (rowA, rowB, columnId) => {
    const getProperty = (row, columnId) => {
      switch (columnId) {
        case "Code":
          return row?.code?.toLowerCase() || "";
        case "Title":
          return row?.title?.toLowerCase() || "";
        case "Discount":
          return row?.discountValue || 0;
        case "Used":
          return row?.usedCount || 0;
        case "EndDate":
          return row?.endDate ? new Date(row.endDate).getTime() : 0;
        case "Status":
          return row?.status || "";
        default:
          return "";
      }
    };

    const a = getProperty(rowA, columnId);
    const b = getProperty(rowB, columnId);

    if (a > b) {
      return 1;
    }
    if (b > a) {
      return -1;
    }
    return 0;
  };

  const columns = [
    {
      name: "Code",
      selector: (row) => row.code,
      sortable: true,
      sortFunction: (a, b) => caseInsensitiveSort(a, b, "Code"),
    },
    {
      name: "Title",
      selector: (row) => row.title,
      sortable: true,
      sortFunction: (a, b) => caseInsensitiveSort(a, b, "Title"),
    },
    {
      name: "Discount",
      selector: (row) => formatDiscount(row),
      sortable: true,
      sortFunction: (a, b) => caseInsensitiveSort(a, b, "Discount"),
    },
    {
      name: "New Patients Only",
      selector: (row) => (row.firstTimeOnly ? "Yes" : "No"),
      sortable: false,
    },
    {
      name: "Used",
      selector: (row) => formatUsage(row),
      sortable: true,
      sortFunction: (a, b) => caseInsensitiveSort(a, b, "Used"),
    },
    {
      name: "Valid Till",
      selector: (row) => formatDate(row.endDate),
      sortable: true,
      sortFunction: (a, b) => caseInsensitiveSort(a, b, "EndDate"),
    },
    {
      name: "Status",
      selector: (row) => (
        <>
          {row.status ? (
            <label className="label label-success m-0">Active</label>
          ) : (
            <label className="label label-danger m-0">Inactive</label>
          )}
        </>
      ),
      sortable: true,
      sortFunction: (a, b) => caseInsensitiveSort(a, b, "Status"),
    },
    {
      name: "Actions",
      selector: (row) => (
        <div className="td-actions table-actions-btns">
          <ul className="list-unstyled mb-0 d-flex justify-content-center">
            {currentUserRole?.editCoupon ? (
              <li className="d-inline-block align-top">
                <OverlayTrigger
                  overlay={<Tooltip id="tooltip-coupon-edit">Edit</Tooltip>}
                  placement="left"
                >
                  <Link
                    to={`/coupon/edit/${row._id}`}
                    type="button"
                    className="btn-link btn-icon btn btn-success "
                  >
                    <FaEdit />
                  </Link>
                </OverlayTrigger>
              </li>
            ) : (
              <li className="d-inline-block align-top">
                <OverlayTrigger
                  overlay={<Tooltip id="tooltip-coupon-edit">Edit</Tooltip>}
                  placement="left"
                >
                  <Link
                    to={""}
                    type="button"
                    className="btn-link btn-icon btn btn-success disabled"
                    disabled
                  >
                    <FaEdit />
                  </Link>
                </OverlayTrigger>
              </li>
            )}
            {currentUserRole?.deleteCoupon ? (
              <li className="d-inline-block align-top">
                <OverlayTrigger
                  overlay={<Tooltip id="tooltip-coupon-delete">Delete</Tooltip>}
                  placement="left"
                >
                  <button
                    onClick={() => showModel(row._id)}
                    type="button"
                    className="btn-link btn-icon btn btn-danger"
                  >
                    <FaTrash />
                  </button>
                </OverlayTrigger>
              </li>
            ) : (
              <li className="d-inline-block align-top">
                <OverlayTrigger
                  overlay={<Tooltip id="tooltip-coupon-delete">Delete</Tooltip>}
                  placement="left"
                >
                  <button
                    type="button"
                    className="btn-link btn-icon btn btn-danger disabled"
                    disabled
                  >
                    <FaTrash />
                  </button>
                </OverlayTrigger>
              </li>
            )}
          </ul>
        </div>
      ),
      sortable: false,
    },
  ];

  const filterSearchDatatable = (status, searchText) => {
    const search = searchText.toLowerCase();
    const filteredItemsResult = couponData.filter((data) => {
      const matchesSearch =
        data?.code?.toLowerCase().includes(search) ||
        data?.title?.toLowerCase().includes(search);
      const matchesStatus = status
        ? data.status.toString() === status
        : true;
      return matchesSearch && matchesStatus;
    });
    setFilteredItems([...filteredItemsResult]);
    setSelectedOption(status);
  };

  const filterDatatable = (text) => {
    setFilterText(text);
    filterSearchDatatable(selectedOption, text);
  };

  const resetFilter = () => {
    setFilterText("");
    setFilteredItems([...couponData]);
    setSelectedOption("");
  };

  const toggleFilterAccordion = () => {
    setIsFilterOpen(!isFilterOpen);
  };

  useEffect(() => {
    if (couponData) {
      setFilteredItems([...couponData]);
    }
  }, [couponData]);

  return (
    <>
      {getDelete ? (
        <SweetAlert
          warning
          showCloseButton
          showCancel
          confirmBtnText="Yes"
          confirmBtnBsStyle="danger"
          cancelBtnBsStyle="light"
          title="Are you sure you want to delete?"
          onConfirm={deleteCoupon}
          onCancel={hideModel}
          focusCancelBtn
          customClass="del-sweet-alert"
        >
          You will not be able to recover this data!
        </SweetAlert>
      ) : null}
      {loader ? (
        <FullPageLoader />
      ) : (
        <div className="pt-2 pt-md-3 blog-category-admin-tablelayout ">
          <Container fluid>
            <Row>
              <Col md="12">
                <Card className="filter-card card">
                  <Card.Header
                    style={{ cursor: "pointer" }}
                    onClick={toggleFilterAccordion}
                  >
                    <div className="d-flex align-items-center justify-content-between table-head">
                      <Card.Title className="text-white" as="h4">
                        Filter
                      </Card.Title>
                      <div
                        style={{
                          transform: isFilterOpen
                            ? "rotate(0deg)"
                            : "rotate(180deg)",
                          transition: "transform 0.3s ease",
                        }}
                      >
                        <IoIosArrowUp />
                      </div>
                    </div>
                  </Card.Header>
                  {isFilterOpen && (
                    <Card.Body>
                      <Row>
                        <Col xl={4} sm={6} className="search-wrap">
                          <Form.Group>
                            <Form.Label className="d-block mb-2 text-white">
                              Search with code or title...
                            </Form.Label>
                            <Form.Control
                              type="text"
                              name="search"
                              placeholder="Search"
                              value={filterText}
                              onChange={(e) => filterDatatable(e.target.value)}
                            ></Form.Control>
                          </Form.Group>
                        </Col>
                        <Col xl={4} sm={6} className="search-wrap">
                          <Form.Group>
                            <Form.Label className="d-block mb-2 text-white">
                              Filter with status...
                            </Form.Label>
                            <select
                              value={selectedOption}
                              onChange={(e) =>
                                filterSearchDatatable(
                                  e.target.value,
                                  filterText
                                )
                              }
                            >
                              <option value="">Select Status</option>
                              <option value="true">Active</option>
                              <option value="false">Inactive</option>
                            </select>
                          </Form.Group>
                        </Col>
                        <Col xl={4} md={6}>
                          <Form.Group>
                            <label className="d-none d-sm-block mb-2 form-label">
                              &nbsp;
                            </label>
                            <div className="d-flex  filter-btns-holder">
                              <button
                                type="button"
                                className="outline-button filter-reset-btn"
                                onClick={() => resetFilter()}
                              >
                                <img
                                  src={resetBtn}
                                  className="img-fluid mr-3"
                                  alt="logo"
                                />
                                Reset
                              </button>
                            </div>
                          </Form.Group>
                        </Col>
                      </Row>
                    </Card.Body>
                  )}
                </Card>

                <div className="datatable-title card d-flex flex-row justify-content-between align-items-center mb-0">
                  <h4 className="card-title">Coupons</h4>
                  {currentUserRole?.addCoupon ? (
                    <div className="btn-add">
                      <Link
                        className="float-sm-right btn-filled d-flex align-items-center"
                        to="/coupon/add"
                      >
                        <span className="add-icon mr-2">
                          <FaPlus />
                        </span>{" "}
                        Add Coupon{" "}
                      </Link>
                    </div>
                  ) : (
                    <div className="btn-add">
                      <Button
                        className="float-sm-right btn-filled d-flex align-items-center disabled"
                        disabled
                      >
                        <span className="add-icon mr-2">
                          <FaPlus />
                        </span>{" "}
                        Add Coupon{" "}
                      </Button>
                    </div>
                  )}
                </div>
                <div className="custom-datatable-pagination">
                  <DataTable
                    columns={columns}
                    data={filteredItems}
                    theme="solarized"
                    pagination
                    className="react-datatable"
                  />
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      )}
    </>
  );
};

export default Index;
